import React from "react";

export const CQSectionContext = React.createContext({insideSection: false});
